import React from "react";
import ReactDOM from "react-dom";
import contrast from "wcag-element-contrast";
import { TextInput } from "@instructure/ui-forms";
import { View } from "@instructure/ui-layout";
import ColorPicker from "./color-picker";
export default class ColorField extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      width: 200
    };

    this.handlePickerChange = color => {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: ColorField.stringifyRGBA(color.rgb)
        }
      });
    };
  }

  static stringifyRGBA(rgba) {
    if (rgba.a === 1) {
      return "rgb(".concat(rgba.r, ", ").concat(rgba.g, ", ").concat(rgba.b, ")");
    }

    return "rgba(".concat(rgba.r, ", ").concat(rgba.g, ", ").concat(rgba.b, ", ").concat(rgba.a, ")");
  }

  componentDidMount() {
    this.setState({
      width: ReactDOM.findDOMNode(this).offsetWidth
    });
  }

  render() {
    return React.createElement(View, {
      as: "div"
    }, React.createElement(TextInput, this.props), React.createElement(ColorPicker, {
      color: contrast.parseRGBA(this.props.value),
      onChange: this.handlePickerChange
    }));
  }

}